/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const evaluateInAppEarlyRequestRpc = {
  serviceName: 'com.hubspot.purchase.motions.rpc.PurchaseMotionsEvaluationService',
  rpcName: 'evaluateInApp',
  auth: 'app',
  fingerprint: '6BBtymEgT83fvjBVnAwcMJwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false
};